export default __webpack_public_path__ + "static/media/extender.9de894a2.png";